import React, { createContext, useEffect, useMemo, useState } from "react";
import { EmbedType } from  "@/interfaces/widgetPanel";



export interface IWebEmbedContext {
  showEmbedWidget: boolean,
  showEmbedModal: boolean,
  isDctEnabled: boolean,
  setShowEmbedModal:(showEmbedModal: boolean) => void
  embedType?: EmbedType,
  setEmbedType: (embedType: EmbedType) => void,
  inputValue?: string,
  setEmbedId: (embedId: string) => void,
  embedId?: string,
  setInputValue: (inputValue:string) => void,
  clearInputValues: any;
}

const WebEmbedDefaults: IWebEmbedContext = {
  showEmbedWidget: false,
  showEmbedModal: false,
  isDctEnabled: false,
  setShowEmbedModal:() => {},
  embedType: null,
  setEmbedType: () => {},
  embedId: null,
  setEmbedId: () => {},
  inputValue: null,
  setInputValue: () => {},
  clearInputValues: ()=> {},
};

export const WebEmbedContext = createContext(WebEmbedDefaults);

const WebEmbedProvider = ({isPageView, isDCTEnabled, children}:{isPageView: boolean, isDCTEnabled:boolean, children:React.ReactNode}) => {
    const showEmbedWidget: boolean = isPageView;
    const [showEmbedModal, setShowEmbedModal] = useState<boolean>(false);
    const [embedType, setEmbedType] = useState<EmbedType>(null);
    const [embedId, setEmbedId] = useState<string>(null);
    const [inputValue, setInputValue] = useState<string>('');
    const [isDctEnabled, setIsDctEnabled] = useState<boolean>(false);

    const context = useMemo(() => (
      {showEmbedWidget, showEmbedModal, setShowEmbedModal, embedType, setEmbedType, embedId, setEmbedId, inputValue, setInputValue, clearInputValues, isDctEnabled}
    ), [showEmbedWidget, showEmbedModal, embedType, embedId, inputValue, isDctEnabled])
    
    useEffect(()=> {
      setInputValue("");
    }, [embedType]);

    useEffect(() => {
      setIsDctEnabled(isDCTEnabled)
    }, [isDCTEnabled])

    function clearInputValues() {
        setShowEmbedModal(false);
        setEmbedType(null);
        setInputValue(null);
    }
    
    return (
      <WebEmbedContext.Provider value={context}>
        {children}
      </WebEmbedContext.Provider>
    );
};

export default WebEmbedProvider;
